/// <amd-module name="TFS/Views/ProjectOverviewPage/RestClient/Operations" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Operations from "TFS/Views/ProjectOverviewPage/Contracts/Operations";

import { IOperationsRestClient } from "TFS/Views/ProjectOverviewPage/RestClient/Operations.Types";

export { IOperationsRestClient } from "TFS/Views/ProjectOverviewPage/RestClient/Operations.Types";

class OperationsRestClient extends RestClientBase implements IOperationsRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Gets an operation from the operationId using the given pluginId.
     * 
     * @param operationId - The ID for the operation.
     * @param pluginId - The ID for the plugin.
     */
    public async getOperation(
        operationId: string,
        pluginId?: string
        ): Promise<Operations.Operation> {

        const queryValues: any = {
            pluginId: pluginId
        };

        return this.beginRequest<Operations.Operation>({
            apiVersion: "4.1-preview.1",
            routeTemplate: "_apis/operations/{operationId}",
            routeValues: {
                operationId: operationId
            },
            queryParams: queryValues
        });
    }

}

export const OperationsClientName = "OperationsForProjectOverview.IOperationsRestClient";

export function getOperationsClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IOperationsRestClient {
    return pageContext.getRestClient<IOperationsRestClient>(OperationsClientName, options);
}

RestClients.add(OperationsClientName, { 
    factory: OperationsRestClient
});
